var _ = { escape: require('lodash.escape') };
module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="booking-calendar__no-opening-times">Unfortunately online appointments are not available at this time.</div>';

}
return __p
};

/*
original source:

<div class="booking-calendar__no-opening-times">
    Unfortunately online appointments are not available at this time.
</div>

*/
